// extracted by mini-css-extract-plugin
export default {"emission__data":"emission__data__3Ov3m","avg":"avg__p3wx6","max":"max__1FdRF","min":"min__KUmdo","total":"total__23PSK"};